var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 11.25H41.25V48.75H48.75V11.25ZM66.8625 19.3875L61.5375 24.7125C64.5698 27.1532 67.0164 30.2426 68.6972 33.7535C70.378 37.2644 71.2503 41.1075 71.25 45C71.25 51.9619 68.4844 58.6387 63.5616 63.5616C58.6387 68.4844 51.9619 71.25 45 71.25C39.5821 71.2533 34.2961 69.5788 29.8682 66.4566C25.4403 63.3345 22.0879 58.9179 20.2713 53.8135C18.4548 48.7092 18.2634 43.1676 19.7234 37.9501C21.1834 32.7327 24.2231 28.0952 28.425 24.675L23.1375 19.3875C19.7585 22.258 16.9782 25.7662 14.9553 29.7115C12.9324 33.6568 11.7066 37.9619 11.3479 42.3811C10.9893 46.8002 11.5047 51.2467 12.8649 55.4666C14.225 59.6865 16.4032 63.5971 19.275 66.975C31.35 81.15 52.65 82.875 66.8625 70.8C70.5995 67.6215 73.5989 63.6668 75.6518 59.2111C77.7048 54.7554 78.7621 49.9059 78.75 45C78.75 35.1375 74.4 25.7625 66.8625 19.3875Z",
    fill: "#FCC67C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.4fa9cda39792b0b5ba5ebe4462b63b1b.svg";
export { ForwardRef as ReactComponent };